import { api } from "./api";

const CACHE_KEY = "tinyapps:tz";

/**
 * Sync the browser's detected timezone to the backend.
 *
 * Production-grade:
 * - Caches in localStorage so we only call the API when the timezone
 *   actually changes (new device, travel, DST edge cases).
 * - Fire-and-forget: never blocks the calling code.
 * - Silent failure: falls back to UTC on the backend if this never runs.
 * - Called from auth init so every logged-in session gets covered.
 */
export function syncTimezone(): void {
  try {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!detected) return;

    const cached = localStorage.getItem(CACHE_KEY);
    if (cached === detected) return;

    api
      .put("/api/notifications/preferences", { timezone: detected })
      .then(() => {
        localStorage.setItem(CACHE_KEY, detected);
      })
      .catch(() => {
        // Silent — UTC fallback on backend is fine
      });
  } catch {
    // Intl API unavailable (very old browser) — ignore
  }
}

/**
 * Clear the cached timezone. Call on sign-out so the next user
 * on the same device gets a fresh sync.
 */
export function clearTimezoneCache(): void {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch {
    // Ignore
  }
}
